import { LayersIcon } from '../../../../../assets/icons/common';
import Modal from '../../../../../components/Modal';
import { BREAK_SECONDS } from '../../constants';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';

const pad = (value: number) => value.toString().padStart(2, '0');

interface Props {
    loading: boolean;
    onNext: () => void;
};

/** Rest between two questions. The next one starts on its own once the break runs out. */
function BreakModal(props: Props) {
    const { loading, onNext } = props;
    const [remaining, setRemaining] = useState(BREAK_SECONDS);

    useEffect(() => {
        if (remaining <= 0) {
            // Out of break — move on whether or not the applicant is ready.
            onNext();
            return;
        }

        const timer = setTimeout(() => setRemaining(prev => prev - 1), 1000);
        return () => clearTimeout(timer);
    }, [remaining]);

    return (
        <Modal
            size='md'
            actions='confirm'
            icon={<LayersIcon />}
            childClassName={styles.wrapper}
            title={`Break Time - ${BREAK_SECONDS / 60} Minutes`}
            confirmButton={{
                text: 'Start Next Question Now',
                type: 'Primary',
                loading: loading,
                onClick: onNext,
            }}
        >
            <h3>
                The next question will start automatically in {pad(Math.floor(remaining / 60))}:{pad(remaining % 60)} minutes.
            </h3>
            <p>If you don’t start the next question, you will lose your chance to answer.</p>
        </Modal>
    )
};

export default BreakModal;
